import { useContext } from 'react';

import {
  CurrentUserContext,
  CurrentUserContextValue,
} from '../providers/CurrentUserProvider';

export const useCurrentRole = () =>
  useContext<CurrentUserContextValue>(CurrentUserContext).role;
